import React, {useEffect} from 'react';
import {backgroundData} from "../../../../../core/dummy/backGroundList";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {optionAction, toggleAction} from "../../../../redux/store";
import callPeerRemoteModule from "../../../../../core/utils/callPeerRemoteModule";

const useBackgroundController = () => {
  const dispatch = useDispatch();
  const {connectMode, backgroundView, CONFIG_DATA} = useSelector(state => ({
    connectMode: state.theme.connectMode,
    backgroundView: state.toggle.backgroundView,
    CONFIG_DATA: state.optionWindow.CONFIG_DATA,
  }),shallowEqual);

  const background = CONFIG_DATA.BACKGROUND;

  const backgroundChangeHandler = async (envCode) => {
    const peer = await callPeerRemoteModule(connectMode);

    dispatch(optionAction.setSendData({
      key: "BACKGROUND",
      value: envCode
    }));


    // if (peer) {
    //   peer.conn.sendData("env:change", envCode);
    // } else if (!peer) {
    //   console.log("Background change : ", envCode);
    //   window && window.postMessage({ msg: "env:change", data: envCode }, '*');
    // }
    if(backgroundView) {
      dispatch(toggleAction.setToggle({ key: "backgroundView", value: false}));
    }
  }

  // useEffect(() => {
  //   if (background) {
  //     backgroundChangeHandler(background);
  //   }
  //
  // }, [background]);


  const backgroundViewEvent = () => {
    dispatch(toggleAction.setToggle({ key: "backgroundView", value: true }));
  }


  return {backgroundChangeHandler, backgroundData, background, backgroundViewEvent}
}

export default useBackgroundController;
